export default __webpack_public_path__ + "static/media/1851.e1ba0ceb.png";